module.exports = __webpack_public_path__ + "static/media/alicebanner_sm2.4afa886d.png";